export type TNativeChannelMergerNode = ChannelMergerNode;
